import type { SubEntryType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  ModalBody,
  UnstyledInput,
} from "@tandemdiabetes/sugarmate-react-components"

import { useEntryModalPrivateContext } from "../EntryModalPrivateContext"
import { ImageThumbnail } from "../ImageThumbnail"
import { SubEntryFooter } from "../SubEntryFooter"
import { SubEntryHeader } from "../SubEntryHeader"
import { useUpdateActivity } from "../useUpdateActivity"

import { CarbsRangeInput } from "./CarbsRangeInput"
import { FoodTitleRow } from "./FoodTitleRow"
import { NutritionDisplay } from "./NutritionDisplay"
import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props {
  updateSubEntry: (s: Partial<EditableSubEntry<ActivityType.Food>>) => void;
  currentSubEntry: EditableSubEntry<ActivityType.Food>;
  currentUserEntry: EditableUserEntry;
  setCurrentUserEntry: (userEntry: EditableUserEntry) => void;
}

export function FoodForm(props: Props) {
  const {
    updateSubEntry,
    currentSubEntry,
    currentUserEntry,
    setCurrentUserEntry,
  } = props

  const { food: activity } = currentSubEntry

  const updateActivity = useUpdateActivity(
    ActivityType.Food,
    activity,
    updateSubEntry,
  )

  const { readOnly } = useEntryModalPrivateContext()

  return (
    <>
      <SubEntryHeader
        activityType={ActivityType.Food}
        currentSubEntry={currentSubEntry}
        currentUserEntry={currentUserEntry}
        setCurrentUserEntry={setCurrentUserEntry}
        readOnly={readOnly}
        closeBtnId="food-entry-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        <UnstyledInput // this input forces some field on the food activity to be defined
          checked={!!activity}
          type="checkbox"
          required
          className={styles.foodInput}
        />
        {!readOnly ? (
          <div>
            <FoodTitleRow
              activity={activity}
              updateActivity={updateActivity}
              updateSubEntry={updateSubEntry}
            />
          </div>
        ) : (
          activity?.title && (
            <Label>
              {activity.title}
            </Label>
          )
        )}
        <CarbsRangeInput
          activity={activity}
          updateActivity={updateActivity}
          readOnly={readOnly}
        />
        <div className={styles.row}>
          <NutritionDisplay
            activity={activity}
            updateActivity={updateActivity}
            readOnly={readOnly}
          />
          <ImageThumbnail
            currentSubEntry={currentSubEntry}
            updateSubEntry={updateSubEntry}
            readOnly={readOnly}
          />
        </div>
        <SubEntryFooter
          currentSubEntry={currentSubEntry}
          currentUserEntry={currentUserEntry}
          updateSubEntry={
            updateSubEntry as (
              s: Partial<EditableSubEntry<SubEntryType>>
            ) => void
          }
          readOnly={readOnly}
          hideImage={readOnly}
        />
      </ModalBody>
    </>
  )
}
